import React from "react";
import { Building2, Cpu, Leaf, ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "CONCRETE DRIVEWAYS",
  category: "\n",
  description: "Precision-engineered concrete solutions for industrial and residential structural integrity and strength.Whether you need to pour concrete on dirt or replace a current concrete driveway, we can handle the entire process. We will go over what you want to accomplish with your concrete, provide all the tools to mix and pour the concrete, and ensure that it is level, clean, and satisfactory.And with concrete driveways, we can make it as simple or as elegant as you want. Whether you prefer a standard gray driveway or one that has stamped designs in it for a classy look, you can achieve whatever look you want with your concrete driveway.",
  icon: Building2,
  categoryClassName: "relative flex size-16 items-center justify-center rounded-sm bg-background/50 p-3 shadow-sm ring-1 ring-border transition-colors group-hover:ring-accent/50 !bg-[url(https://sampsonconcreteandmasonry.net/wp-content/uploads/2026/04/promotion-1024x768-1.jpg)]"
}, {
  title: "BASEMENT WALKOUTS\xA0",
  category: "\n",
  description: "Our team of experienced professionals is well-versed in creating custom Side Entrances tailored to your specific needs and preferences. Whether you envision a simple and practical design or a more elaborate entranceway, we have the expertise to bring your vision to life.\xA0",
  icon: Cpu
}, {
  title: "Custom Masonry",
  category: "\n",
  description: "\"Is the mortar on your brickwork crumbling? Are your garden walls cracking? Don't let your home's value and safety erode. My masonry service offers durable, expert repairs and installations that make your home stronger and more beautiful. I use only the highest quality materials and provide a warranty on all my work. A solid foundation isn't just about strength; it’s about protecting your investment and peace of mind.\"\n⬛Bricks, blocks and stones masonry\n⬛Veneer stones laying\n⬛Chimneys repair\n⬛Cracks repair\n⬛bricks repair\n⬛Repointing\xA0",
  icon: Leaf
}];
export default function OurEngineeringServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="19717" id="our-services" ref={ref} className={`bg-background py-[160px] transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-12 gap-y-16 md:gap-x-[80px]">
          {/* Header Section */}
          <div className="col-span-12 mb-8 md:mb-12">
            <div className="flex flex-col items-start justify-center">
              <h2 className="border-l-4 border-accent pl-6 text-[48px] font-default uppercase leading-none tracking-tight text-foreground">
                Our Specialized Services
              </h2>
            </div>
          </div>

          {/* Services Grid */}
          <div className="col-span-12 grid grid-cols-1 gap-8 md:grid-cols-3 md:gap-[80px]">
            {services.map((service, i) => <div key={i} data-index={i} className="h-full">
                <Card className="group relative h-full overflow-hidden border border-border bg-card transition-all duration-500 ease-out hover:z-10 hover:scale-[1.02] hover:border-accent hover:border-t-2 hover:shadow-[0_0_30px_-10px_var(--color-accent)]">
                  <CardHeader className="pb-4">
                    <div className="mb-6 flex items-center justify-between">
                      <div className={`${service.categoryClassName || ""} relative flex size-16 items-center justify-center rounded-sm bg-background/50 p-3 shadow-sm ring-1 ring-border transition-colors group-hover:ring-accent/50`}>
                        <service.icon className="size-8 text-accent fill-accent/10" strokeWidth={2} />
                      </div>
                      <span className="font-mono text-sm font-medium tracking-wider text-primary">
                        {service.category}
                      </span>
                    </div>
                    <CardTitle className="text-2xl font-default font-bold text-foreground group-hover:text-accent transition-colors duration-300">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base font-sans leading-relaxed text-muted-foreground">
                      {service.description}
                    </CardDescription>
                    
                    <Link to="/ProjectsPage" className="mt-8 flex items-center text-sm font-semibold text-foreground opacity-0 transition-all duration-300 group-hover:translate-x-2 group-hover:opacity-100">
                      <span className="mr-2">Explore Service</span>
                      <ArrowRight className="size-4 text-accent" />
                    </Link>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}